import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no-image.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-fc04cc8a")

_pushScopeId("data-v-fc04cc8a")
const _hoisted_1 = { id: "TalkNowTalents" }
const _hoisted_2 = { class: "talk-now-talents" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline talk-headline" }, "今すぐお話しする", -1)
const _hoisted_4 = { class: "talk-now-talents-list" }
const _hoisted_5 = {
  key: 0,
  class: "talk-now-img",
  src: _imports_0
}
const _hoisted_6 = { class: "held-live-box" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "held-live-text txt txt-wt txt-detail" }, "開催中", -1)
const _hoisted_8 = { class: "talent-name txt txt-small" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nowTalents, (nowTalent, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "talk-now-talent-box",
            onClick: ($event: any) => (_ctx.openTalent(nowTalent.talentID))
          }, [
            (nowTalent.mainImage === '')
              ? (_openBlock(), _createBlock("img", _hoisted_5))
              : (_openBlock(), _createBlock(_component_Imgix, {
                  key: 1,
                  class: "talk-now-img",
                  src: nowTalent.mainImage,
                  imageSize: _ctx.imageSize
                }, null, 8, ["src", "imageSize"])),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, {
                class: "held-live-icon",
                icon: "phone"
              }),
              _hoisted_7
            ]),
            _createVNode("div", _hoisted_8, _toDisplayString(nowTalent.formatDisplayName), 1)
          ], 8, ["onClick"]))
        }), 256))
      ])
    ])
  ]))
})